// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listStyles } from "@guestsupply/Overrides/Widgets/Brand/BrandGallery";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

listStyles.titleText = {
    variant: "h2",
    css: css`
        text-align: left;
        margin-bottom: 20px;
    `,
};
listStyles.link = {
    css: css`
        width: 230px;
        height: 230px;
        ${xScreen("lte", "sm")} {
            width: 156px;
            height: 156px;
        }
    `,
};
listStyles.image = {
    css: css`
        max-width: 100%;
        max-height: 100%;
        height: auto;
        border-radius: 4px;
    `,
};

listStyles.brandsWrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        gap: 46px;
        ${xScreen("lte", "md")} {
            gap: 20px;
        }
        ${xScreen("lte", "sm")} {
            gap: 16px;
        }
        ${xScreen("lte", 359)} {
            justify-content: center;
        }
    `,
};
